import database from '../firebase/firebase'

export const initalizerTypes = {
    FETCH_COMPANY_DATA: "company/GETTING_DATA",
    FETCH_VACANCY_DATA: "jobs/GETTING_DATA"
};

export const setCompany = (data) => ({
    type: initalizerTypes.FETCH_COMPANY_DATA,
    data
});

export const setVacancies = (vacancies) => ({
    type: initalizerTypes.FETCH_VACANCY_DATA,
    vacancies
})

export const startSetCompany = () => {
    return (dispatch, getState) => {
        const uid = getState().auth.uid
        return database.collection(`companies/${uid}/jobs`).get().then((snapshot) => {
            let jobs = []
            snapshot.forEach((doc) => {
                jobs.push(doc.data())
            });
            dispatch(setVacancies(jobs))
        })
        .then(() => {
            return database.collection('companies').doc(uid).get()
        })
        .then((doc) => {
            dispatch(setCompany(doc.data()))
        }).catch((err) => console.log(err))
    }
}

export const startShowVacancies = () => {
    return (dispatch) => {
        return database.collection(`vacancies`)
        .get()
        .then((snapshot) => {
            let jobs = []
            snapshot.forEach((doc) => {
                jobs.push(doc.data())
            });
            dispatch(setVacancies(jobs))
        })
        .catch((err) => console.log(err))
    }
}